import issueDom from "./issueDom.js";
import mqttDom from './mqttDom.js'
import $event from './../../../common/event.js';
import $jsonp from './../../../common/ajax.js'
// 列表布点
function ManageIssue() {
	// 当前初始化是否执行的标志，true-> 未执行；false -> 已执行
	this.eventFlag = true;
}

ManageIssue.prototype = {
	init: function() {
			this.param = window.commercial;
			// TODO: 防止多次发起请求修改，待上线
			// if(!this.param.entityidlist) {
			// 	return;
			// }

			this.getIssueList(100,this.setIssueTools);

			if(this.param.common.commonType == 25|| this.param.common.commonType == 26){

				this.getIssueList(10011,this.getMqttList);
			}

			this.domEvent(this.eventFlag);
			this.eventFlag = false;

	},

	// 根据参数请求置顶布点
	getIssueList: function(productId,func) {
		var _this = this;
        $jsonp("//infotophttpapi.58.com/state/get",
            {
            	entityType: _this.param.entitytype,
            	infoIds: _this.param.entityidlist.replace(/,/g,"|"),
            	productIds: productId,
            	isExisted: 1,
            	isAvailabe:1
            },
            function(result){
            	// success 方法

                if(result.errorcode == 0 && result.code == 200){
                    func.call(_this,result.data,productId);
                }
            },
            function() {
            	// error方法
            });
	},

	// 根据参数请求名企头条布点
	getMqttList: function(exist, productId) {
		var _this = this;
        $jsonp("//infotophttpapi.58.com/infoTop/queryInfos",
            {
            	entityType : _this.param.entitytype,
            	entityIds : _this.param.entityidlist,
            	productId : productId,
            },
            function(result){
            	// success 方法
                if(result.code == 200){
                    _this.mqttCreatedData(result,exist,productId)
                }
            },
            function() {
            	// error方法
            	// _this.flag = true;
            });


	},

	// 时间补全

	addDateLength:function(date){
		if(date<10){
			return "0"+date;
		}else{
			return date;
		}
	},

	// 名企头条时间处理

	mqttDateOprate:function(star,end){
		var state = '<br>推广中，${time}结束。',date = '',//判断是新建还是管理
		    star = (star.substr(0,4) + '-' + star.substr(4,2) + '-' + star.substr(6,2) + '-'
		    	  + star.substr(8,2) + '-' + star.substr(10,2) + '-' + star.substr(12,2)).split("-"),

		    splitEnd = end.substr(0,4) + '/' + end.substr(4,2) + '/' + end.substr(6,2) + ' '
		   		+ end.substr(8,2) + ':' + end.substr(10,2) + ':' + end.substr(12,2),
		   	end = new Date((new Date(splitEnd)).getTime() - 1000),

		    end = (end.getFullYear()+'-'+this.addDateLength(end.getMonth()+1)+'-'
		   		+ this.addDateLength(end.getDate())+'-'
		   		+ this.addDateLength(end.getHours())+'-'
		   		+ this.addDateLength(end.getMinutes())+'-'
		   		+ this.addDateLength(end.getSeconds())).split("-"),

		    nowTime = new Date() ,
		   	now = (nowTime.getFullYear()+'-'+this.addDateLength(nowTime.getMonth()+1)+'-'
		   		+ this.addDateLength(nowTime.getDate())+'-'
		   		+ this.addDateLength(nowTime.getHours())+'-'
		   		+ this.addDateLength(nowTime.getMinutes())+'-'
		   		+ this.addDateLength(nowTime.getSeconds())).split("-"),

		   	strRange = new Date(star[0]+"/" + star[1]+"/" + star[2])- new Date(now[0]+"/" + now[1]+"/" + now[2]),

		   	endRange = new Date(end[0]+"/" + end[1]+"/" + end[2])- new Date(now[0]+"/" + now[1]+"/" + now[2]);



		   	if(now.join("") - star.join("") < 0 ){
		   		state = "<br>新建成功，${time}开始推广。";
		   		if(star[0]-now[0]>0){
		   			date += "明年"+star[1]+"月" + star[2]+"日";
		   		}else if(strRange == 24*60*60*1000){
		   			date += "明天";
		   		}else if(strRange==0){
		   			date += "今天";
		   		}else{
		   			date += star[1] + "月" + star[2] + "日";
		   		}
		   	}else{
		   		if(end[0]-now[0]>0){
		   			date += "明年"+star[1]+"月" + star[2]+"日";
		   		}else if(endRange == 24*60*60*1000){
		   			date += "明天";
		   		}else if(endRange==0){
		   			date += "今天";
		   		}else{
		   			date += end[1] + "月" + end[2] + "日";
		   		}
		   	}

		return state.replace("${time}",date)


	},

	// 民企头条数据封装

	mqttCreatedData:function(data,exist,productId){
		for(var item in exist){
			var prod = exist[item][productId];
			if(prod.availabe){
				var isType = prod.existed;
				var url = `//brand.58.com/lvzhou/advistor/advert/?entityId=${item}&entityType=${this.param.entitytype}&productId=10011&source=${this.param.common.source}`;
				var time = '';
				if(isType){
					time = this.mqttDateOprate(data.data[item].startTime+'',data.data[item].endTime+'');
					url+=`&brandId=${data.data[item].subscribeId}`;
				}
				var ele = mqttDom(this.param.common.commonType,isType,url,time),
	            $commercialItem = $('#commercial' + item),
	            $iframe = $('#tuiguang_' + item);
	            if($commercialItem.find('.commercial_link_zl').length <= 0) {
						// 当前帖子中没有置顶入口布点，则append
					$commercialItem.append(ele);
				} else {
					// 当前帖子中有置顶入口布点，则直接return
					return;
				}
				$commercialItem.addClass("commercial_vip_context commercial_mqtt");
				$commercialItem.height("100px");
				// $commercialItem.addClass("commercial_mqtt");
				$iframe[0].setAttribute('style','height:49px !important')
			}
		}
	},

	// 获取各个页面的布点dom结构
	getIssueDom: function(isType, id) {
		// 处理一下link
		var link = `//zhiding.58.com/pc/infotop/${isType ? 'manageZhiding' : 'createZhiding'}?entityType=${this.param.entitytype}&entityId=${id}&productId=100&source=${this.param.common.source}`;
		var itemDom = issueDom(this.param.common.commonType, isType, link)
		return itemDom;
	},

	// 数组转换为对象，key值为entityId,主要用于优培，将优培的数组转换为对象，方便渲染的时候，直接取值

	arrayTOobj:function(array){
		var obj = {};
		for(var i = 0;i<array.length;i++){
			obj[array[i].infoId] = array[i];
		}
		return obj;
	},
	// 实现布点，productId表示页面类型，置顶100
	setIssueTools: function(data, productId) {
		var youpei;
		if(this.param.infolist&&this.param.infolist.length>0){
            youpei = this.arrayTOobj(this.param.infolist);
		}
		for(var item in data) {
			var id = item;
			var product = data[item][productId];
			var isType = false;
			if(product.availabe) {
				isType = product.existed;

				var $commercialItem = $('#commercial' + item);

				if($commercialItem.find('.commercial_link_hyt').length <= 0) {

                    var ele = this.getIssueDom(isType, id);

                    if(this.param.common.commonType == 15) {
                        $("#tuiguang_"+item).height("67.5");
                    }

                    if(this.param.common.commonType == 21
                        || this.param.common.commonType == 22
                        || this.param.common.commonType == 25
                        || this.param.common.commonType == 26) {

                    	var youpeiList = youpei?youpei[id]:{};

						if(youpeiList.isJobTrain){
							// var isTypeText = ;
							ele = `<div class="commercial_vip"><p class="commercial_empty"></p><h3 class="commercial_vip_title">优培</h3><p class="commercial_vip_tips">跨类固定位置高流量展示</p><a href="//employer.58.com/zhiyepeixun?orderid=${youpeiList.youPeiOrderId}&infoid=${id}" target="_blank"><span data-href="dataLink" class="commercial_vip_top commercial_link_hyt">${youpeiList.isYouPeiOrder?'管理':'新建'}</span></a></div>`;
						}else{
                            ele = this.getIssueDom(isType, id);
						}

                        if(!$commercialItem.attr("style")||$commercialItem.attr("style").indexOf("100px")==-1){
                            $("#tuiguang_"+item)[0].setAttribute('style','height:75px !important');
                        }
                        $("#commercial"+item).addClass("commercial_vip_context");
                    }else{
                        ele = this.getIssueDom(isType, id);
					}

                    // 当前帖子中没有置顶入口布点，则append
                    $commercialItem.append(ele);


				} else {
					// 当前帖子中有置顶入口布点，则直接return
					return;
				}

			}
		}
	},

	// 事件绑定
	domEvent: function(eventFlag) {
		if(!eventFlag){return;}
		var _this = this;
		$event($('body')).$on('click', '.commercial_link', function(e) {
			var url = $(this).attr("data-href"),html="置顶";
			if(url.indexOf("brand.58.com")>-1){
				html="头条"
			}
			// 代客中心无需在iframe中打开，所以此时判断是否是代客中心，是则直接新建页打开，否则创建iframe打开
			if(url) {
				_this.createIframe(url,html);
			} else {
				return;
			}
            // _this.createIframe(url);
            window.event? window.event.cancelBubble = true : e.stopPropagation();
		})

		$event(top.$('body')).$on('click', '.commercial_close', function(e) {
			var url = window.top.$("#commercial_iframe").attr("src");
			if(url&&url.indexOf("status=success")>-1){
				_this.closeRefresh();
				return ;
			}
			window.top.$('#commercial_box_zl').remove();
		})
	},

	// 关闭弹窗并刷新页面

	closeRefresh : function(){
		top.$('#commercial_box_zl').remove();
		top.location.reload();
	},

	// 创建顶层ifream
	createIframe: function(url,type) {
		top.$("#commercial_box_zl").remove();
        var div = `
        	<div id="commercial_box_zl" style="width: 100%; height: 100%; position: fixed; z-index: 1987; top: 0px; left: 0px; overflow: hidden; ">
        		<div style="position: fixed; z-index: 1988; top: 0px; left: 0px; right: 0; bottom: 0;overflow: hidden; background: rgb(0, 0, 0);opacity: 0.6;filter: Alpha(opacity=60);"></div>
                <div style="position: absolute; top:0;left:0;bottom:0;right:0;margin:auto;width:820px;height:610px;background:#fff;border:5px solid rgba(0,0,0,.5); z-index:2000;">
                    <div style="overflow:hidden;padding-left:10px;height:30px;text-shadow: 0 1px 0 rgba(255, 255, 255, .7);background-color: #bdc6cd;">
                        <span style="float:left;line-height:30px;font-size:12px;color:#4c5a5f">${type}</span>
                        <span class="commercial_close" style="cursor:pointer;width:40px;height:30px;line-height:30px;font-size:20px;color:#4c5a5f;;text-align:center;float:right;background:url('data:image/png;base64,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') 5px 4px no-repeat;"></span>
                    </div>
                    <iframe src="${url}" id="commercial_iframe" name="Openinfotop_shortCut" frameborder="0" allowtransparency="true" style="width: 100%; height: 580px; border: 0px none;"></iframe>
                </div>
            </div>`;
        top.$('body').append(div)
  //       $event(top.$('body')).$on('click', '.commercial_close', function(e) {
		// 	if(window.top.$("#commercial_iframe").attr("src").indexOf("status=success")>-1){
		// 		_this.closeRefresh();
		// 		return ;
		// 	}
		// 	window.top.$('#commercial_box_zl').remove();
		// })
	}
}

export default ManageIssue
